export default __webpack_public_path__ + "static/media/ai-boat-project.d2335a75.jpg";